const seizure_questions  = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"F[0].Page_1[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"F[0].Page_1[0].RadioButtonList[3]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page_1[0].RadioButtonList[2]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Evidence review",
         number: "0"
      },
      "presidence":"Yes",
      "maxLength":105,
      "radioGroup":"F[0].Page_1[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"F[0].Page_1[0].IdentifyEvidence[0]",
      "textanswer":""
   },
   {
      "question":"Has ##name## had witnessed Seizures?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "2",
         title: "MEDICAL HISTORY",
         number: "2E"
      },
      "presidence":"Yes",
      "maxLength":90,
      "ref":0,
      "dbqName_yes":"F[0].#subform[1].Yes2E[0]",
      "dbqName_no":"F[0].#subform[1].No2E[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please describe, including relationship of witnesses to Veteran",
      "textdbqName":"F[0].#subform[1].IfYes2C[3]",
      "textanswer":""
   },
   // {
   //    "question":"Does ##name## have any findings, signs or symptoms attributable to Seizure disorder (epilepsy) activity?",
   //    "sub":"",
   //    "type":"yesno",
   //    "show": true,
   //    "section": {
   //       page: "2",
   //       title: "FINDINGS, SIGNS AND SYMPTOMS",
   //       number: "3"
   //    },
   //    "presidence":"Yes",
   //    "ref":2,
   //    "dbqName_yes":"F[0].#subform[1].Yes3[0]",
   //    "dbqName_no":"F[0].#subform[1].No3[0]",
   //    "answer":"",
   // },
   {
      "question":"Does ##name## have any findings, signs or symptoms attributable to Seizure disorder (epilepsy) activity",
      "sub":"Please check all symptoms that apply",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "small": true,
      // "refId":1,
      "cols": 2,
      "section": {
         page: "2",
         title: "FINDINGS, SIGNS AND SYMPTOMS",
         number: "3"
      },
      "questions":[
         {
            "main":"Generalized tonic-clonic convulsion",
            "dbqName":"F[0].#subform[1].Signs1[0],F[0].#subform[1].Yes3[0]",
            "answer":""
         },
         {
            "main":"Episodes of unconsciousness",
            "dbqName":"F[0].#subform[1].Signs2[0],F[0].#subform[1].Yes3[0]",
            "answer":""
         },
         {
            "main":"Brief interruption in consciousness or conscious control",
            "dbqName":"F[0].#subform[1].Signs3[0],F[0].#subform[1].Yes3[0]",
            "answer":""
         },
         {
            "main":"Episodes of staring",
            "dbqName":"F[0].#subform[1].Signs4[0],F[0].#subform[1].Yes3[0]",
            "answer":""
         },
         {
            "main":"Episodes of rhythmic blinking of the eyes",
            "dbqName":"F[0].#subform[1].Signs5[0],F[0].#subform[1].Yes3[0]",
            "answer":""
         },
         {
            "main":"Episodes of nodding of the head",
            "dbqName":"F[0].#subform[1].Signs6[0],F[0].#subform[1].Yes3[0]",
            "answer":""
         },
         {
            "main":"Episodes of sudden jerking movement of the arms, trunk or head",
            "dbqName":"F[0].#subform[1].Signs7[0],F[0].#subform[1].Yes3[0]",
            "answer":""
         },
         {
            "main":"Episodes of sudden loss of postural control (akinetic type)",
            "dbqName":"F[0].#subform[1].Signs8[0],F[0].#subform[1].Yes3[0]",
            "answer":""
         },
         {
            "main":"Episodes of complete or partial loss of use of one or more extremities",
            "dbqName":"F[0].#subform[1].Signs9[0],F[0].#subform[1].Yes3[0]",
            "answer":""
         },
         {
            "main":"Episodes of random motor movements",
            "dbqName":"F[0].#subform[1].Signs10[0],F[0].#subform[1].Yes3[0]",
            "answer":""
         },
         {
            "main":"Episodes of psychotic manifestations",
            "dbqName":"F[0].#subform[1].Signs11[0],F[0].#subform[1].Yes3[0]",
            "answer":""
         },
         {
            "main":"Episodes of hallucinations",
            "dbqName":"F[0].#subform[1].Signs12[0],F[0].#subform[1].Yes3[0]",
            "answer":""
         },
         {
            "main":"Episodes of perceptual illusions",
            "dbqName":"F[0].#subform[1].Signs13[0],F[0].#subform[1].Yes3[0]",
            "answer":""
         },
         {
            "main":"Episodes of abnormalities of thinking",
            "dbqName":"F[0].#subform[1].Signs14[0],F[0].#subform[1].Yes3[0]",
            "answer":""
         },
         {
            "main":"Episodes of abnormalities of memory",
            "dbqName":"F[0].#subform[1].Signs15[0],F[0].#subform[1].Yes3[0]",
            "answer":""
         },
         {
            "main":"Episodes of abnormalities of mood",
            "dbqName":"F[0].#subform[1].Signs16[0],F[0].#subform[1].Yes3[0]",
            "answer":""
         },
         {
            "main":"Episodes of autonomic disturbances",
            "dbqName":"F[0].#subform[1].Signs17[0],F[0].#subform[1].Yes3[0]",
            "answer":""
         },
         {
            "main":"Episodes of speech disturbances",
            "dbqName":"F[0].#subform[1].Signs18[0],F[0].#subform[1].Yes3[0]",
            "answer":""
         },
         {
            "main":"Episodes of impairment of vision",
            "dbqName":"F[0].#subform[1].Signs19[0],F[0].#subform[1].Yes3[0]",
            "answer":""
         },
         {
            "main":"Episodes of disturbances of gait",
            "dbqName":"F[0].#subform[1].Signs20[0],F[0].#subform[1].Yes3[0]",
            "answer":""
         },
         {
            "main":"Episodes of tremors",
            "dbqName":"F[0].#subform[1].Signs21[0],F[0].#subform[1].Yes3[0]",
            "answer":""
         },
         {
            "main":"Episodes of visceral manifestations",
            "dbqName":"F[0].#subform[1].Signs22[0],F[0].#subform[1].Yes3[0]",
            "answer":""
         },
         {
            "main":"Other",
            "dbqName":"F[0].#subform[1].Signs24[0],F[0].#subform[1].Yes3[0]",
            "answer":""
         },
      ],
      "answer":""
   },
   {
      "question":"Describe the findings, Signs or symptoms that are checked in previous question",
      "sub":"",
      "type":"textarea",
      "show": true,
      // "refId":2,
      "section": {
         page: "2",
         title: "FINDINGS, SIGNS AND SYMPTOMS",
         number: "3"
      },
      "options":[],
      "maxLength":70,
      "dbqName":"F[0].#subform[1].Describe[0]",
      "answer":""
   },
   // {
   //    "question":"Please provide the approximate date of ##redHeading## activity",
   //    "redHeading": "First Seizure",
   //    "sub":"",
   //    "type":"calendar",
   //    "concat":true, //concat month, date, year and fill single field
   //    "show": true,
   //    "section": {
   //       page: "3",
   //       title: "TYPE AND FREQUENCY OF SEIZURE ACTIVITY",
   //       number: "4B"
   //    },
   //    "questions":[
   //       {
   //          "title":"Month",
   //          "month": true,
   //          "dbqName":"F[0].Page_2[0].Date1[0]",
   //          "options":[
   //             {
   //                "values":[
   //                   "January",
   //                   "February",
   //                   "March",
   //                   "April",
   //                   "May",
   //                   "June",
   //                   "July",
   //                   "August",
   //                   "September",
   //                   "October",
   //                   "November",
   //                   "December"
   //                ],
   //                "answer":"January"
   //             },
   //          ]
   //       },
   //       {
   //          "title":"Year",
   //          "year": true,
   //          "dbqName":"F[0].Page_2[0].Date1[0]",
   //          "options":[
   //             {
   //                "values":[
   //                   "2023",
   //                   "2022",
   //                   "2021",
   //                   "2020",
   //                   "2019",
   //                   "2018",
   //                   "2017",
   //                   "2016",
   //                   "2015",
   //                   "2014",
   //                   "2013",
   //                   "2012",
   //                   "2011",
   //                   "2010",
   //                   "2009",
   //                   "2008",
   //                   "2007",
   //                   "2006",
   //                   "2005",
   //                   "2004",
   //                   "2003",
   //                   "2002",
   //                   "2001",
   //                   "2000",
   //                ],
   //                "answer":"2021"
   //             },
   //          ]
   //       },         
   //    ]
   // },
   // {
   //    "question":"Please provide the approximate date of the ##redHeading## activity",
   //    "redHeading": "Most Recent Seizure",
   //    "sub":"",
   //    "type":"calendar",
   //    "concat":true, //concat month, date, year and fill single field
   //    "show": true,
   //    "section": {
   //       page: "3",
   //       title: "TYPE AND FREQUENCY OF SEIZURE ACTIVITY",
   //       number: "4B"
   //    },
   //    "questions":[
   //       {
   //          "title":"Month",
   //          "month": true,
   //          "dbqName":"F[0].Page_2[0].Date2[0]",
   //          "options":[
   //             {
   //                "values":[
   //                   "January",
   //                   "February",
   //                   "March",
   //                   "April",
   //                   "May",
   //                   "June",
   //                   "July",
   //                   "August",
   //                   "September",
   //                   "October",
   //                   "November",
   //                   "December"
   //                ],
   //                "answer":"January"
   //             },
   //          ]
   //       },
   //       {
   //          "title":"Year",
   //          "year": true,
   //          "dbqName":"F[0].Page_2[0].Date2[0]",
   //          "options":[
   //             {
   //                "values":[
   //                   "2023",
   //                   "2022",
   //                   "2021",
   //                   "2020",
   //                   "2019",
   //                   "2018",
   //                   "2017",
   //                   "2016",
   //                   "2015",
   //                   "2014",
   //                   "2013",
   //                   "2012",
   //                   "2011",
   //                   "2010",
   //                   "2009",
   //                   "2008",
   //                   "2007",
   //                   "2006",
   //                   "2005",
   //                   "2004",
   //                   "2003",
   //                   "2002",
   //                   "2001",
   //                   "2000",
   //                ],
   //                "answer":"2021"
   //             },
   //          ]
   //       },         
   //    ]
   // }, 
   {
      "question":"Has ##name## ever had minor seizures?",
      "sub":"Check all that apply",
      "type":"checkbox",
      "multi": false,
      "small": true,
      "show": true,
      "cols": 2,
      "section": {
         page: "3",
         title: "TYPE AND FREQUENCY OF SEIZURE ACTIVITY",
         number: "4C"
      },
      "questions":[
         {
            "main":"0-1",
            "dbqName":"F[0].Page_2[0].indicate1[0],F[0].Page_2[0].Yes4B[0]",
            "answer":"",
         },
         {
            "main":"2 or more",
            "dbqName":"F[0].Page_2[0].indicate2[0],F[0].Page_2[0].Yes4B[0]",
            "answer":"",
            "multi": false,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"0-4 per week",
                  "dbqName":"F[0].Page_2[0].indicate3[0]",
                  "answer":""
               },
               {
                  "main":"5-8 per week",
                  "dbqName":"F[0].Page_2[0].indicate4[0]",
                  "answer":""
               },
               {
                  "main":"9-10 per week",
                  "dbqName":"F[0].Page_2[0].indicate5[0]",
                  "answer":""
               },
               {
                  "main":"More than 10 per week",
                  "dbqName":"F[0].Page_2[0].indicate6[0]",
                  "answer":""
               },
            ],
         },
         {
            "main":"No minor seizures",
            "dbqName":"F[0].Page_2[0].No4B[0]",
            "answer":"",
         },                   
      ],
      "answer":""
   },
   {
      "question":"Has ##name## ever had major Seizures (characterized by the generalized tonic-clonic convulsion with unconsciousness)?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "TYPE AND FREQUENCY OF SEIZURE ACTIVITY",
         number: "4D"
      },
      "presidence":"Yes",
      "ref":2,
      "dbqName_yes":"F[0].Page_2[0].Yes4C[0]",
      "dbqName_no":"F[0].Page_2[0].No4C[0]",
      "answer":"",
   },
   {
      "question":"Number of major seizures",
      "sub":"Select only one",
      "type":"radioTiles",
      "multi": false,
      "show": false,
      "small": true,
      "refId":1,
      "cols": 3,
      "section": {
         page: "3",
         title: "TYPE AND FREQUENCY OF SEIZURE ACTIVITY",
         number: "4D"
      },
      "questions":[
         {
            "main":"None in past 2 years",
            "dbqName":"F[0].Page_2[0].Frequency1[0]",
            "answer":""
         },
         {
            "main":"At least 1 in past 2 years",
            "dbqName":"F[0].Page_2[0].Frequency2[0]",
            "answer":""
         },
         {
            "main":"At least 2 in past year",
            "dbqName":"F[0].Page_2[0].Frequency3[0]",
            "answer":""
         }
      ],
      "answer":""
   },
   {
      "question":"Average frequency of major seizures",
      "sub":"Select only one",
      "type":"radioTiles",
      "multi": false,
      "show": false,
      "refId":2,
      "small": true,
      "cols": 2,
      "section": {
         page: "3",
         title: "TYPE AND FREQUENCY OF SEIZURE ACTIVITY",
         number: "4D"
      },
      "questions":[
         {
            "main":"Less than 1 in past 6 months",
            "dbqName":"F[0].Page_2[0].Frequency4[0]",
            "answer":""
         },
         {
            "main":"At least 1 in past 6 months",
            "dbqName":"F[0].Page_2[0].Frequency5[0]",
            "answer":""
         },
         {
            "main":"At least 1 in 4 months over past year",
            "dbqName":"F[0].Page_2[0].Frequency6[0]",
            "answer":""
         },
         {
            "main":"At least 1 in 3 months over past year",
            "dbqName":"F[0].Page_2[0].Frequency7[0]",
            "answer":""
         },
         {
            "main":"At least 1 per month over past year",
            "dbqName":"F[0].Page_2[0].Frequency8[0]",
            "answer":""
         }
      ],
      "answer":""
   },   

   {
      "question":"Has ##name## ever had minor psychomotor seizures?",
      "sub":"Check all that apply",
      "type":"checkbox",
      "multi": false,
      "small": true,
      "show": true,
      "cols": 2,
      "section": {
         page: "3",
         title: "TYPE AND FREQUENCY OF SEIZURE ACTIVITY",
         number: "4E"
      },
      "questions":[
         {
            "main":"0-1",
            "dbqName":"F[0].Page_2[0].indicate1[1],F[0].Page_2[0].Yes4B[1]",
            "answer":"",
         },
         {
            "main":"2 or more",
            "dbqName":"F[0].Page_2[0].indicate2[1],F[0].Page_2[0].Yes4B[1]",
            "answer":"",
            "multi": false,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"0-4 per week",
                  "dbqName":"F[0].Page_2[0].indicate3[1]",
                  "answer":""
               },
               {
                  "main":"5-8 per week",
                  "dbqName":"F[0].Page_2[0].indicate4[1]",
                  "answer":""
               },
               {
                  "main":"9-10 per week",
                  "dbqName":"F[0].Page_2[0].indicate5[1]",
                  "answer":""
               },
               {
                  "main":"More than 10 per week",
                  "dbqName":"F[0].Page_2[0].indicate6[1]",
                  "answer":""
               },
            ],
         },
         {
            "main":"No minor seizures",
            "dbqName":"F[0].Page_2[0].No4B[1]",
            "answer":"",
         },                   
      ],
      "answer":""
   },
   {
      "question":"Has ##name## ever had major psychomotor Seizures (characterized by automatic states and/or generalized convulsions with unconsciousness)?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "TYPE AND FREQUENCY OF SEIZURE ACTIVITY",
         number: "4F"
      },
      "presidence":"Yes",
      "ref":2,
      "dbqName_yes":"F[0].Page_2[0].Yes4C[1]",
      "dbqName_no":"F[0].Page_2[0].No4C[1]",
      "answer":"",
   },
   {
      "question":"Number of major seizures",
      "sub":"Select only one",
      "type":"radioTiles",
      "multi": false,
      "show": false,
      "small": true,
      "refId":1,
      "cols": 3,
      "section": {
         page: "3",
         title: "TYPE AND FREQUENCY OF SEIZURE ACTIVITY",
         number: "4F"
      },
      "questions":[
         {
            "main":"None in past 2 years",
            "dbqName":"F[0].Page_2[0].Frequency1[1]",
            "answer":""
         },
         {
            "main":"At least 1 in past 2 years",
            "dbqName":"F[0].Page_2[0].Frequency2[1]",
            "answer":""
         },
         {
            "main":"At least 2 in past year",
            "dbqName":"F[0].Page_2[0].Frequency3[1]",
            "answer":""
         }
      ],
      "answer":""
   },
   {
      "question":"Average frequency of major seizures",
      "sub":"Select only one",
      "type":"radioTiles",
      "multi": false,
      "show": false,
      "refId":2,
      "small": true,
      "cols": 2,
      "section": {
         page: "3",
         title: "TYPE AND FREQUENCY OF SEIZURE ACTIVITY",
         number: "4F"
      },
      "questions":[
         {
            "main":"Less than 1 in past 6 months",
            "dbqName":"F[0].Page_2[0].Frequency4[1]",
            "answer":""
         },
         {
            "main":"At least 1 in past 6 months",
            "dbqName":"F[0].Page_2[0].Frequency5[1]",
            "answer":""
         },
         {
            "main":"At least 1 in 4 months over past year",
            "dbqName":"F[0].Page_2[0].Frequency6[1]",
            "answer":""
         },
         {
            "main":"At least 1 in 3 months over past year",
            "dbqName":"F[0].Page_2[0].Frequency7[1]",
            "answer":""
         },
         {
            "main":"At least 1 per month over past year",
            "dbqName":"F[0].Page_2[0].Frequency8[1]",
            "answer":""
         }
      ],
      "answer":""
   }, 


   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
      "show": true,
      "section": {
         page: "5",
         title: "REMARKS",
         number: "8"
      },
      "options":[],
      "maxLength":2930,
      "dbqName":"F[0].Page_4[0].REMARKSIfany[0]",
      "answer":""
   },
]
   
    export default seizure_questions ;